"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const CardMedia_1 = require("@material-ui/core/CardMedia");
const styles_1 = require("@material-ui/core/styles");
const React = require("react");
const InformationDialog_1 = require("../dialog/InformationDialog");
const SurveyScreenStyle_1 = require("./jss/SurveyScreenStyle");
const SurveyImage = ({ imageClass, imageUrl, imageTitle, classes }) => {
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(CardMedia_1.default, { onClick: handleOpen, image: imageUrl, className: imageClass }), (0, jsx_runtime_1.jsx)(InformationDialog_1.default, Object.assign({ maxWidth: "lg", open: open, onClose: handleClose, hideButton: true, noSpaces: true }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: classes.optionImageModal }, { children: (0, jsx_runtime_1.jsx)("img", { className: classes.optionImageModalImage, src: imageUrl, alt: imageTitle }) })) }))] }));
};
exports.default = (0, styles_1.withTheme)((0, styles_1.withStyles)(SurveyScreenStyle_1.default)(SurveyImage));
//# sourceMappingURL=SurveyImage.js.map